export enum CONTRACT_TYPE {
  STUDENT_ORG_WITH_COMPANY = 'StudentOrgWithCompany',
  STUDENT_ORG = 'StudentOrg',
}

export interface SealtedContract {
  id: string;
  contractType: CONTRACT_TYPE;
  userSealedAt: Date;
  dellaSealedAt: Date;
  contractText: string;
  expires?: Date;
  createdAt: Date;
  updatedAt: Date;
}

export interface SealedContractResponse {
  contracts: SealtedContract[];
}

export interface GetPregeneratedContractResponse {
  html?: string;
}

export interface GetPregenrationContractPayload {
  type: CONTRACT_TYPE;
}

export interface ProduceContractPayload {
  type: CONTRACT_TYPE;
  ipAddress: string;
}
